import React, { useEffect } from 'react'
import { Select } from 'antd'

function populateSelect() {
  const options = []
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth()

  for (let i = 0; i < 12; i++) {
    const date = new Date(currentYear, currentMonth - i, 1) // Subtrai i meses
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const monthName = date.toLocaleString('pt-BR', { month: 'long' }) // Nome do mês em português

    options.push({
      label: `${
        monthName.charAt(0).toUpperCase() + monthName.slice(1)
      } ${year}`,
      value: `${year}/${String(month).padStart(2, '0')}/01`
    })
  }

  return options
}

const options = populateSelect()

interface Props extends Readonly<{ setMonthFilter: (value: string) => void }> {}

export function MonthCalendar({ setMonthFilter }: Props) {
  useEffect(() => {
    setMonthFilter(options[0]?.value ?? '')
  }, [setMonthFilter])

  return (
    <Select
      defaultValue={options[0].value}
      onChange={(value: any) => setMonthFilter(value)}
      style={{ width: '100%' }}
    >
      {options.map(opt => (
        <Select.Option key={opt.value} value={opt.value}>
          {opt.label}
        </Select.Option>
      ))}
    </Select>
  )
}
